<template>
  <apexchart
    ref="chart"
    type="area"
    height="300"
    :options="chartOptions"
    :series="series"/>
</template>

<script>
  export default {
    data() {
      return {
        series: [],
      }
    },
    computed: {
      chartOptions() {
        return {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "20%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 1,
          },
          markers: {
            size: 2,
          },
          xaxis: {
            categories: [],
          },
          fill: {
            opacity: 0.7,
          },
        }
      }
    },
    methods:{
      update(data){
        this.$refs.chart.updateSeries(
          [
            {
              name: data.pointTitle,
              data: data.values,
            }
          ],
          true
        );
        this.$refs.chart.updateOptions(
          {
            xaxis: {
              categories: data.xaxis,
            },
            title: {
              text: data.chartTitle,
              align: "left",
            },
          },
          true,
          true
        );
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/LineChart.vue